<template>
    <div class="flex items-center gap-x-8">
        <UserCircleIcon v-if="file === null && current_url === null" class="size-12 text-gray-300" aria-hidden="true" />
        <img v-if="file !== null" :src="preview_url" class="size-24 flex-none rounded-full bg-gray-800 object-cover" alt="" />
        <img v-if="file === null && current_url !== null" :src="current_url" class="size-24 flex-none rounded-full bg-gray-800 object-cover" alt="" />
        <div>
            <button type="button" @click.prevent="clickSelectFile" class="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50 cursor-pointer">
                {{ $t('avatar.change_button') }}
            </button>
            <p class="mt-2 text-xs/5 text-gray-600">{{ $t('avatar.file_info') }}</p>
        </div>

        <input
            type="file"
            accept="image/*"
            @change="selectFile"
            name="avatar"
            ref="avatar-uploader-input"
            class="hidden">
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {mapActions} from "vuex";

import { UserCircleIcon } from '@heroicons/vue/24/solid'

export default defineComponent({
    name: "AvatarComponent",

    components: {
        UserCircleIcon,
    },

    props: {
        current_url: String,
    },

    data() {
        return {
            isUploadingAvatar: false,

            file: null as File | null,

            preview_url: null as string | null,

            updated: false,
        }
    },

    methods: {
        ...mapActions({
            uploadAvatar: "user/uploadAvatar",

            errorAlert: "alerts/error",
            successAlert: "alerts/success",
        }),

        selectFile(event: Event) {
            const input = event.target as HTMLInputElement;
            const file = input.files?.[0];

            if (file) {
                this.file = file;

                this.preview_url = URL.createObjectURL(this.file);

                this.isUploadingAvatar = true;

                this.uploadAvatar({file: this.file})
                    .then(() => {
                        this.isUploadingAvatar = false;

                        this.successAlert({
                            message: this.$t('avatar.update_success'),
                            timeout: 10
                        });
                    })
                    .catch(({data}) => {
                        if(data.message) {
                            this.errorAlert({
                                message: this.$t('avatar.update_error_with_message', { message: data.message }),
                                timeout: 20
                            });
                        } else {
                            this.errorAlert({
                                message: this.$t('avatar.update_error_unknown'),
                            });
                        }

                        this.isUploadingAvatar = false;
                    });
            }
        },

        clickSelectFile() {
            if(this.isUploadingAvatar) {
                return;
            }

            const input = this.$refs["avatar-uploader-input"] as HTMLInputElement;
            input.click();
        },
    }
});
</script>